import { Alert, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const Dropzone = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'dragOver',
})<{ dragOver?: boolean }>(({ dragOver }) => ({
  border: `2px dashed ${dragOver ? 'rgb(2, 122, 242)' : '#fafafa17'}`,
  borderRadius: 16,
  padding: '56px 32px',
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  background: dragOver
    ? 'linear-gradient(135deg, rgba(2,122,242,0.08) 0%, rgba(2,122,242,0.02) 100%)'
    : 'linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.005) 100%)',
  '&:hover': {
    borderColor: 'rgb(2, 122, 242)',
  },
}));

export const UploadIconBubble = styled(Box)({
  width: 80,
  height: 80,
  borderRadius: '50%',
  background: 'linear-gradient(135deg, rgb(2, 122, 242) 0%, rgb(2, 122, 242) 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 24px',
  boxShadow: '0 12px 32px -8px rgba(2, 122, 242, 0.4)',
});

export const StatusAlert = styled(Alert)({
  borderRadius: 12,
  '& .MuiAlert-icon': { fontSize: 24 },
});

export const TreeContainer = styled(Box)({
  border: '1px solid #fafafa17',
  borderRadius: 8,
  padding: 8,
  flexGrow: 1,
  minHeight: 0,
  overflowY: 'auto',
});

export const StepBadge = styled(Box)({
  width: 32,
  height: 32,
  borderRadius: '50%',
  background: 'rgba(2, 122, 242, 0.12)',
  color: 'rgb(2, 122, 242)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  position: 'relative',
});

export const StepBadgeNumber = styled(Box)({
  position: 'absolute',
  bottom: -2,
  right: -2,
  width: 16,
  height: 16,
  borderRadius: '50%',
  background: 'rgb(2, 122, 242)',
  color: 'white',
  fontSize: '0.65rem',
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ExampleTree = styled(Box)({
  padding: 16,
  borderRadius: 8,
  border: '1px solid #fafafa17',
  backgroundColor: 'rgba(255,255,255,0.02)',
  fontFamily: 'monospace',
  fontSize: '0.8rem',
  lineHeight: 1.7,
});

export const OverlineLabel = styled(Typography)({
  letterSpacing: 1.5,
});
